<template>
  <div
    class="p-4 lg:px-12 lg:py-6 box-container flex flex-col lg:flex-row items-center lg:items-start"
  >
    <svg role="presentation" focusable="false" tabindex="-1"   class="icon w-16 lg:mr-12 lg:w-20 mb-3" alt="" svg-inline  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 100 151">
  <path fill="#E6E6E6" fill-rule="evenodd" d="M47.8 150.7c16.6 0 30.2-2.3 30.2-5.1s-13.6-5.2-30.2-5.2c-16.7 0-30.3 2.4-30.3 5.2 0 2.8 13.6 5.1 30.3 5.1Z" clip-rule="evenodd"/>
  <path fill="#074C26" fill-rule="evenodd" d="M77.9 89.8c-4.8-2.3-7.6-5.7-7-10a1.6 1.6 0 0 0-3-.5c-1 6.4 3.4 10.8 8.6 13.3 5.3 2.6 12 3.5 17.1 2.7a1.6 1.6 0 1 0-.5-3.1A28 28 0 0 1 78 89.8Zm-18 54.6a1.6 1.6 0 0 0-1.5-1.6 31.7 31.7 0 0 1-2.5-.2c4.5-18 2.6-29.1-2-39.7a1.6 1.6 0 0 0-3 1.2c4.6 10.3 6.4 21 1.5 39.4a1.6 1.6 0 0 0 1.2 2c1.1.2 2.9.4 4.7.4a1.6 1.6 0 0 0 1.6-1.5Z" clip-rule="evenodd"/>
  <path fill="#3D843D" fill-rule="evenodd" d="M40 40a40 40 0 1 0 0 80l40-40-40-40Z" clip-rule="evenodd"/>
  <path fill="#8CC42D" fill-rule="evenodd" d="M40 0a40 40 0 1 0 0 80l40-40L40 0Z" clip-rule="evenodd"/>
  <path fill="#65A435" fill-rule="evenodd" d="m80 80 20-20-20-20-20 20 20 20ZM40 80l20-20-20-20A40 40 0 0 0 5.4 60 40 40 0 0 0 40 80Z" clip-rule="evenodd"/>
  <path fill="#074C26" fill-rule="evenodd" d="M38.4 51.6c3.2.1 5.6 3 5.4 6.4-.2 3.5-3 6.2-6 6-3.3 0-5.7-3-5.5-6.4.2-3.4 2.9-6.1 6-6Z" clip-rule="evenodd"/>
  <path fill="#fff" fill-rule="evenodd" d="M35.8 54.3c.8 0 1.4.8 1.4 1.8s-.8 1.7-1.6 1.7-1.5-.9-1.4-1.9c0-1 .7-1.7 1.6-1.6Z" clip-rule="evenodd"/>
  <path fill="#074C26" fill-rule="evenodd" d="M61 43.5c2.8.1 4.9 2.6 4.7 5.6-.1 3-2.5 5.2-5.2 5.1-2.8 0-4.9-2.5-4.7-5.5.2-3 2.5-5.3 5.3-5.2Z" clip-rule="evenodd"/>
  <path fill="#fff" fill-rule="evenodd" d="M58.8 45.7c.7 0 1.3.8 1.2 1.7 0 .8-.6 1.5-1.4 1.5-.7 0-1.3-.8-1.3-1.7 0-.8.7-1.5 1.5-1.5Z" clip-rule="evenodd"/>
  <path fill="#074C26" fill-rule="evenodd" d="M68.3 71c.4 7-2.8 12.7-7.4 13.1-4.6.4-8.8-4.7-9.6-11.6a47 47 0 0 0 17-1.5Z" clip-rule="evenodd"/>
  <path fill="#FF6041" fill-rule="evenodd" d="M52 75.7c3.6-1.1 11.8.8 14.7 3.9-1.3 2.6-3.4 4.3-5.8 4.5-3.8.4-7.4-3.2-9-8.4Z" clip-rule="evenodd"/>
  <path fill="#074C26" fill-rule="evenodd" d="M43.3 145.7a1.6 1.6 0 0 0-1.2-1.9 31.8 31.8 0 0 1-2.4-.6c7.8-17 8-28.2 5.4-39.5a1.6 1.6 0 1 0-3 .7c2.4 11 2.2 21.8-6 39a1.6 1.6 0 0 0 .8 2.1c1 .5 2.8 1 4.6 1.4.8.2 1.7-.4 1.8-1.2ZM3.4 111.4a1.6 1.6 0 0 0 2-1.1c1.1-4.4 4.1-9.6 8-13.8 4-4.2 8.6-6.9 12.8-6.8a1.6 1.6 0 1 0 .1-3.1c-5.6-.2-11 3.3-15.2 7.8a37.8 37.8 0 0 0-8.8 15 1.6 1.6 0 0 0 1.1 2Z" clip-rule="evenodd"/>
  <path fill="#074C26" fill-rule="evenodd" d="M3.3 106.5A1.2 1.2 0 0 0 4 108l.9.6c.2.2.3.5.3 1a1.2 1.2 0 1 0 2.4-.4c-.1-.8-.4-1.5-.9-2.1-.5-.6-1.1-1-1.9-1.3a1.2 1.2 0 0 0-1.5.7Zm87-11.4a1.2 1.2 0 0 0 1.2-1c0-.5.2-.8.3-1 .2-.3.4-.5.8-.7a1.2 1.2 0 1 0-1-2.1c-.6.3-1.2.7-1.7 1.4-.4.6-.7 1.3-.8 2.1a1.2 1.2 0 0 0 1.1 1.3Z" clip-rule="evenodd"/>
</svg>
    <MSpinner v-if="state === 'loading'" class="my-16 mx-auto" size="w-24 h-24" />
    <div v-else-if="state === 'initial'">
      <p class="text-20 lg:text-24 font-semibold mb-3">
        {{ $t('new_provider_email.title') }}
      </p>
      <p
        class="lg:text-18 mb-5"
        v-html="
          $t('new_provider_email.description', {
            fromCountry: corridor.countryFrom.labels.from,
            toCountry: corridor.countryTo.labels.to,
          })
        "
      />
      <EmailForm
        :submit-label="$t('new_provider_email.submit')"
        :conditions-text="$t('email_alert.by_continuing')"
        @submit="onSignUp"
      >
        <span class="block text-14 font-semibold mb-2">
          {{ $t('new_provider_email.enter_email') }}
        </span>
      </EmailForm>
    </div>
    <div v-else-if="state === 'success'">
      <p class="text-20 lg:text-24 font-semibold mb-3">{{ $t('thanks') }}</p>
      <p class="lg:text-18 mb-3">
        {{ $t('new_provider_email.send_you_email') }}
      </p>
    </div>
    <div v-else-if="state === 'error'">
      <p class="text-20 lg:text-24 font-semibold mb-3">
        {{ $t('errors.something_went_wrong') }}
      </p>
      <p class="lg:text-18 mb-3">
        {{ $t('new_provider_email.error_description') }}
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { SignUpPromptType } from '@core/analytics/objects/SignUpPrompt'
import { SignUpPromptClick } from '@core/analytics/core-events/moneyTransfer'
import EmailForm from './email-form.vue'
import { getTabFilters } from './helpers/process-tabs'
import type { PaymentType, Corridor } from '@core/types/imt'

type NewProviderAlertCase = 'NO_RESULTS' | 'POOR_RESULTS'

const SignUpPromptClientType: Record<NewProviderAlertCase, SignUpPromptType> = {
  NO_RESULTS: SignUpPromptType.NewProviderAlertNoResults,
  POOR_RESULTS: SignUpPromptType.NewProviderAlertPoorResults,
}

const props = withDefaults(
  defineProps<{
    case: NewProviderAlertCase
    comparisonId: string | null
    currentTab?: PaymentType | null
  }>(),
  { currentTab: null },
)

const corridor = inject('corridor') as Corridor

const { $lang, $cookie, $track } = useNuxtApp()
const logger = useLogger('new-provider-alert-card')

const {
  public: { subscriptions },
} = useRuntimeConfig()

const state = ref<'initial' | 'loading' | 'success' | 'error'>('initial')

async function onSignUp(email: string) {
  state.value = 'loading'

  await $track(SignUpPromptClick(SignUpPromptClientType[props.case], 'Email'))

  if (!subscriptions.apiEndpoint) {
    return onError(Error('The subscriptions apiEndpoint is missing'))
  }
  try {
    const resp = await $fetch<Response, string>(`${subscriptions.apiEndpoint}/subscriptions`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        subscriptionCase: props.case,
        email,
        userId: $cookie.value.getId(),
        language: $lang,
        comparisonId: props.comparisonId,
        countryFrom: corridor.countryFrom.iso,
        countryTo: corridor.countryTo.iso,
        currencyFrom: corridor.currencyFrom.iso,
        currencyTo: corridor.currencyTo.iso,
        amount: corridor.amount || corridor.defaultAmount,
        params: {
          tabType: props.currentTab,
          ...(props.currentTab ? getTabFilters(props.currentTab) : {}),
        },
        creationLocation: 'new_provider_alert_prompt',
      }),
    })
    if (resp.status >= 400) {
      return onError(Error(resp.statusText))
    }
  } catch (e) {
    return onError(e instanceof Error ? e : Error(JSON.stringify(e)))
  }
  setSignedIn()
  state.value = 'success'
}

function onError(error: Error) {
  logger.error(error)
  setSignedIn(true)
  state.value = 'error'
}
</script>
